import { SVGProps } from 'react';

const EmailIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.3736 12.218L19.8796 9.163C20.5806 8.689 20.9996 7.898 20.9996 7.052V7.052C20.9996 5.642 19.8576 4.5 18.4486 4.5H5.56565C4.15665 4.5 3.01465 5.642 3.01465 7.051V7.051C3.01465 7.897 3.43365 8.688 4.13465 9.163L8.64065 12.218C10.6736 13.596 13.3406 13.596 15.3736 12.218V12.218Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3 7.051V16.5C3 18.157 4.343 19.5 6 19.5H18C19.657 19.5 21 18.157 21 16.5V7.052"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default EmailIcon;
